import ContextualMenu, { ContextualMenuProps } from './ContextualMenu';

export type { ContextualMenuProps };
export default ContextualMenu;
